const emailTypes = Object.freeze({
    HOME: "HOME",
    WORK: "WORK"
});

export default emailTypes;